<template>
    <!-- 登录 -->
    <div class="box" style="min-width: 1600px;">
        <NavBar navIndex="6"></NavBar>
        <div style="padding:30px;"></div>
        <div style="position:relative;width: 100%;">
            <img style="display: block;width: 100%;" src="../assets/job-fair-bg.png" alt="">
            <div style="position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);font-size:38px;font-weight: bold;text-align: center;color: #fff;">
                人才招聘
                <div class="content-title-border"></div>
            </div>
        </div>

    
        <div style="background-color: #F7F7F7;padding: 0 0 50px;">
            <div style="width: 1200px;margin: auto;">
                <div style="display: flex;align-items: center;padding: 30px 0 20px;">
                    <div class="select-status" style="cursor:pointer;"@click="goHome()"> 首页 </div>
                    <div style="margin: 0 10px;"> > </div>
                    <div class="select-status" style="cursor:pointer;" @click="showJob()">人才招聘</div>
                    <div style="margin: 0 10px;"> > </div>
                    <div style="cursor:pointer;">{{jobContent.inviteOne}}</div>
                        
                </div>
    
                <div style="background-color: #fff;padding: 30px 40px;box-sizing: border-box;">
                    <div class="teacher-classify" >
                        {{jobContent.inviteOne}}
                        <div class="teacher-classify-border" ></div>
                    </div>
    
                    <div style="color: #999999;font-size: 12px;">发布时间：{{jobContent.time}}</div>
                    <div style="margin: 20px 0;width: 100%;height:1px;background-color: #F7F7F7;"></div>
                    <div style="color:#333333;font-weight:600;">工作地点：{{jobContent.inviteAddress}}</div>
                    <div style="color:#333333;font-weight:600;margin-top: 10px;">工作性质：{{jobContent.inviteNature}}</div>
                    <div style="color:#333333;font-weight:600;margin-top: 10px;">学历要求：{{jobContent.inviteStudy}}</div>
                    <div style="color:#333333;font-weight:600;margin-top: 10px;">工作年限：{{jobContent.inviteCount}}</div>
                    <div style="color:#333333;font-weight:600;margin-top: 10px;">薪资待遇：{{jobContent.invitePay}}</div>
                    <div style="color:#333333;font-weight:600;margin-top: 10px;">招聘人数：{{jobContent.inviteTwo}}位</div>
                    <div  style="font-size:20px;color:#333333;font-weight:600;margin: 30px 0 10px;">职位描述</div>
                    <!-- <div style="line-height: 30px;">1、组织参与重要项目的创意构思、文案及客户提案, 给予前期提案、设计创意说明及后期结案报告等服务；2、执行并监督所负责项目的创意构思和文案；3、稿件思路清晰，能够完成稿件写作思路规划；4、协助领导进行创意提案，保证工作的顺利推进；5、独立撰写各类稿件（新闻稿、综述稿、评论稿、专访稿等）、策划方案、报告等任职资格1、大专及以上学历；2、一年以上市场策划及文案工作经验；3、能够准确捕捉产品亮点，具备恰如其分的文字表现能力；4、熟悉专业创意方法，思维敏捷，洞察力强，文字功底扎实，语言表达能力强；福利待遇：1.公司为员工提供以市场标杆，以能力、绩效为标准，具有市场竞争力的薪资待遇；2.为员工缴纳社会保险和办理住房公积金、带薪年假、法定节假日、小暑假</div> -->
                    
                    <!-- <span style="font-size:18px;"><s:property :value="jobContent.inviteDesc" escape="false"/></span> -->
                    <div id="formStr" v-html="jobContent.inviteDesc">{{ jobContent.inviteDesc }}</div>
    
                    <div style="display: flex;justify-content: space-between;margin-top: 20px;">
                        <div style="display: flex;justify-content: center;align-items: center;margin: 30px 0 10px;">
                            <img style="width: 16px;height:16px;margin-right: 10px;" src="../assets/phone-icon.png" alt="">
                            <div style="color: #333333;font-weight: 600;">有意向请电联：18867429116</div>
                        </div>
    
                        <div style="display: flex;justify-content: center;align-items: center;margin: 30px 0 10px;">
                            <img style="width: 16px;height:16px;margin-right: 10px;" src="../assets/mail-icon.png" alt="">
                            <div style="color: #333333;font-weight: 600;">邮箱号码：hzjy@hncshzjyjt.com</div>
                        </div>
    
                        <div style="display: flex;justify-content: center;align-items: center;margin: 30px 0 10px;">
                            <img style="width: 16px;height:16px;margin-right: 10px;" src="../assets/wx-icon.png" alt="">
                            <div style="color: #333333;font-weight: 600;">微信号：hzjy@hncshzjyjt.com</div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    
        <Footer></Footer>
    </div>
    </template>
    
    <script>
    import NavBar from '@/components/navBar.vue'
    import Footer from '@/components/Footer.vue'
    import { jobFair } from "@/request/api"
    
    export default {
        name: 'jobDetail',
        components: {
            NavBar,
            Footer
        },
        data() {
            return {
                page_control: "1",
                jobData: [],
                total: 6,
                jobContent: {},//工作信息详情
            };
        },
        mounted(){
            let that = this
            let obj = JSON.parse(sessionStorage.getItem("job_detail"))
            // console.log(JSON.parse(sessionStorage.getItem("job_detail")))
            if(obj){
                that.jobContent = JSON.parse(sessionStorage.getItem("job_detail"))
            }
            else { // 没有内容就返回工作页
                this.$router.push({name:'jobFair'})
            }
        },
        methods: {
            lookJob(e){
                let that = this
                that.page_control = "2"
                console.log(e)
                this.jobContent = e
            },
            showJob(){
                // this.page_control = "1"
                this.$router.push({name:'jobFair'})
            },
            goHome(){
                this.$router.push('/')
            },
            changepagination(e){
                console.log(e)
                let that = this
                jobFair(
                    "pageSize=6&pageNum=" + e
                ).then(res=>{
                    console.log("招聘",res.data.result)
                    let data = res.data.result
                    data.forEach(function(res,index){
                        res.time = res.insertDate.slice(0,10)
                    })
                    that.jobData = data
                })
            }
    
        }
    }
    </script>
    
    <style scoped>
    .content-title-border {
        position:absolute;
        width: 32px;
        height:4px;
        background-color: #fff;
        left: 50%;
        transform: translateX(-50%);
        bottom: -15%;
    }
    .job-cell {
        width: 31%;
        background-color: #fff;
        padding:30px;
        box-sizing: border-box;
        margin: 10px;
        cursor:pointer
    }
    .job-cell:hover {
        box-shadow: 0 0 8px 5px #EAEAEA;
    }
    
    .teacher-classify {
        position:relative;
        font-size:26px;
        font-weight: bold;
        width: 70%;
        margin-bottom: 25px;
    }
    .teacher-classify-border {
        position:absolute;
        width: 32px;
        height:2px;
        background-color: #0050A7;
        bottom: -25%;
    }
    .select-status {
    
    }
    .select-status:hover {
        color: #004EA3;
        /* font-weight: 600; */
    }
    
    /* 分页 */
    .pagination-block {
        text-align: center;
        margin: 30px;
    }
    </style>
            